<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
      <p class="modal-title">{{nzModalData.nzTitle}}</p>
    </div>

    <div class="flex justify-end">
        @if((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail){
            <button (click)="handleAddRawMaterial()" class="button primary-button" [disabled]="isLocked">
                Añadir materia prima
            </button>
        }
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (plainRawMaterials && plainRawMaterials.length > 0) {
            <nz-table
                #basicTable
                [nzData]="plainRawMaterials"
                class="m-0 p-0"
                nzSize="small"
                [nzLoading]="isLoading"
                nzTableLayout="auto"
                [nzBordered]="true"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                [nzScroll]="{ y: (tableHeight || 0) + 'px' }"
                >
                <thead>
                <tr>
                    @if(finalProducts.length > 1){
                        <th id="finalProduct" zWidth="20%">Producto final asignado</th>
                    }
                    <th id="article" nzWidth="20%">Artículo</th>
                    <th id="batch" nzWidth="20%">Lote</th>
                    <!-- <th id="packaging" nzWidth="20%">Formato</th> -->
                    <th id="quantity"nzWidth="10%">Cantidad a consumir</th>
                    @if(this.canDelete && this.isFromOrderProcessDetail){
                        <th id="action" nzWidth="10%">Acciones</th>
                    }
                </tr>
                </thead>
                <tbody>
                @for (rawMaterialToUse of basicTable.data; track rawMaterialToUse; let idx = $index) {
                    <tr>
                        @if((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail){
                            @if(finalProducts.length > 1){
                                <td>
                                    <nz-select class="w-full" [(ngModel)]="rawMaterialToUse.finalProduct" [compareWith]="compareByObject" [disabled]="isLocked">
                                        @for(finalProduct of finalProducts; track finalProduct){
                                            <nz-option [nzValue]="finalProduct" [nzLabel]="finalProduct.article?.name + (finalProduct.articleBatch ?  ' - ' + finalProduct.articleBatch.batchNumber! : '') "></nz-option>
                                        }
                                    </nz-select>
                                </td>
                            }
                            <td>
                                <nz-select [nzDisabled]="isDisabled(rawMaterialToUse.createdById) || isLocked" nzShowSearch class="w-full" [(ngModel)]="rawMaterialToUse.article" (ngModelChange)="onArticleChanged($event, idx)"
                                [compareWith]="compareById" [nzFilterOption]="filterArticlesSelector">
                                    @for(article of articles; track article){
                                        <nz-option [nzValue]="article" [nzLabel]="article.name"  [nzDisabled]="isArticleDisabled(article.id)"></nz-option>
                                    }
                                </nz-select>
                            </td>
                            <td>
                                <nz-select nzShowSearch class="w-full" [(ngModel)]="rawMaterialToUse.articleBatch" [compareWith]="compareByBatchNumber"
                                [disabled]="isDisabled(rawMaterialToUse.createdById) || !plainRawMaterials[idx].article?.useBatches || isLocked" (ngModelChange)="onBatchChanged(rawMaterialToUse.articleBatch!, idx)"
                                (nzOnSearch)="onArticleBatchSearch($event, idx)"
                                [nzFilterOption]="filterArticleBatchesSelector">
                                    @for(batch of batchesOfArticlesInRawMaterials.get(idx); track batch.batchNumber){
                                        <nz-option [nzValue]="batch" [nzLabel]="batch.batchNumber || ''" [nzDisabled]="isArticleBatchDisabled(batch.id!)"></nz-option>
                                    }
                                </nz-select>
                            </td>
                            <td>
                                <nz-input-group [nzSuffix]="rawMaterialToUse.measurementUnit">
                                    <input onfocus="select()" nz-input [(ngModel)]="rawMaterialToUse.quantity" type="number" [disabled]="isDisabled(rawMaterialToUse.createdById) || isLocked" />
                                </nz-input-group>
                            </td>
                        }
                        @else {
                            @if(finalProducts.length > 1){
                                <td>
                                    {{rawMaterialToUse.finalProduct.article?.name + (rawMaterialToUse.finalProduct.articleBatch ?  ' - ' + rawMaterialToUse.finalProduct.articleBatch.batchNumber! : '') }}
                                </td>
                            }
                            <td>
                                {{ rawMaterialToUse.article?.name }}
                            </td>
                            <td>
                                {{ rawMaterialToUse.articleBatch?.batchNumber }}
                            </td>
                            <!-- <td>
                                {{ rawMaterialToUse.packaging ? (rawMaterialToUse.packaging.externalBatchNumber || rawMaterialToUse.packaging.batchNumber) + ' ' + rawMaterialToUse.packaging.packagingType?.name : '-'}}
                            </td> -->
                            <td>
                                {{ rawMaterialToUse.quantity }}  {{ rawMaterialToUse.measurementUnit }}
                            </td>
                        }

                        @if(this.canDelete && this.isFromOrderProcessDetail){
                            <td>
                                <div class="flex justify-center">
                                    <button
                                        (click)="deleteRawMaterial(idx)"
                                        nz-button nzType="text" nzShape="circle" class="table-icon"
                                        [nzTooltipTitle]="'Eliminar materia prima'" nzTooltipPlacement="bottom" nz-tooltip
                                        [disabled]="isDisabled(rawMaterialToUse.createdById)"
                                    >
                                        <span nz-icon nzType="delete"></span>
                                    </button>
                                </div>
                            </td>
                        }
                    </tr>
                }
                </tbody>
            </nz-table>
        }
        @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button
        (click)="handleCancel()"
        class="button secondary-button mr-2"
        >
            Cancelar
        </button>

        @if(((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail) && !isLocked){
            <button nz-button class="button primary-button" (click)="handleSave()" [nzLoading]="isSaving">
                Aceptar
            </button>
        }
    </div>
</div>
